// Product Inside-Zoom (safe for <picture>)
// Works with <img class="js-zoom" data-zoom="..."> rendered by format-image.liquid
(function () {
  function makeZoomable(img) {
    if (!img || img.dataset.zoomBound === '1') return;
    const zoomSrc = img.getAttribute('data-zoom');
    if (!zoomSrc) return;
    img.dataset.zoomBound = '1';

    // Use the <figure> (or img parent) as the host so we don't alter <picture> structure
    const host = img.closest('figure') || img.parentElement;
    if (!host) return;

    host.classList.add('zoom-host');
    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    host.style.overflow = 'hidden';

    // Overlay canvas above the picture
    const canvas = document.createElement('div');
    canvas.className = 'zoom-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    host.appendChild(canvas);

    // Preload
    const pre = new Image();
    pre.src = zoomSrc;
    pre.onload = () => {
      canvas.style.backgroundImage = `url("${zoomSrc}")`;
      canvas.style.opacity = '0';
      sync(); // ensure size on load
    };

    let active = false;
    const zoomFactor = 3;

    function setActive(on) {
      active = on;
      canvas.style.opacity = on ? '1' : '0';
      canvas.style.backgroundSize = on ? `${zoomFactor * 100}% auto` : '100% auto';
      host.classList.toggle('zoom-active', on);
      host.style.cursor = on ? 'zoom-out' : 'zoom-in';
    }

    function sync() {
      // Canvas already absolutely positioned via CSS; nothing else needed here
    }

    function move(e) {
      if (!active) return;
      const rect = host.getBoundingClientRect();
      const cx = e.touches ? e.touches[0].clientX : e.clientX;
      const cy = e.touches ? e.touches[0].clientY : e.clientY;
      const xp = Math.max(0, Math.min(1, (cx - rect.left) / rect.width));
      const yp = Math.max(0, Math.min(1, (cy - rect.top) / rect.height));
      canvas.style.backgroundPosition = `${xp * 100}% ${yp * 100}%`;
    }

    host.addEventListener('mouseenter', () => setActive(true));
    host.addEventListener('mouseleave', () => setActive(false));
    host.addEventListener('mousemove', move);
    host.addEventListener('touchstart', (e) => { setActive(!active); move(e); }, { passive: true });
    host.addEventListener('touchmove', move, { passive: true });

    const ro = new ResizeObserver(sync);
    ro.observe(host);
    window.addEventListener('load', sync);
    sync();
  }

  function initProductZoom(root = document) {
    root.querySelectorAll('img.js-zoom').forEach(makeZoomable);
  }
  window.initProductZoom = initProductZoom;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductZoom());
  } else {
    initProductZoom();
  }

  // Re-init on Shopify events and DOM changes that swap media
  document.addEventListener('shopify:section:load', (e) => initProductZoom(e.target));
  document.addEventListener('product-media-change', () => initProductZoom());

  const gallery = document.querySelector('[data-product-gallery]') || document.body;
  const mo = new MutationObserver(() => initProductZoom());
  mo.observe(gallery, { childList: true, subtree: true });
})();
